import { render, staticRenderFns } from "./withdrawalHistory.vue?vue&type=template&id=4a1128b1&scoped=true"
import script from "./withdrawalHistory.vue?vue&type=script&lang=js"
export * from "./withdrawalHistory.vue?vue&type=script&lang=js"
import style0 from "./withdrawalHistory.vue?vue&type=style&index=0&id=4a1128b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1128b1",
  null
  
)

export default component.exports